export var DATEPICKER_FORMATS;
(function (DATEPICKER_FORMATS) {
    DATEPICKER_FORMATS["DD_MM_YYYY"] = "DD_MM_YYYY";
    DATEPICKER_FORMATS["MM_YYYY"] = "MM_YYYY";
})(DATEPICKER_FORMATS || (DATEPICKER_FORMATS = {}));
